import React from 'react';

import HelperCard from 'src/components/common/HelperCard';
import { useTranslation } from 'react-i18next';

const SMJCmpSelectorHelperRender = () => {
  const { t } = useTranslation();
  return (
    <HelperCard
      title={t('smartmessaging.smartjourney.campaignSelector.helperTitle')}
      content={t(`smartmessaging.smartjourney.campaignSelector.helper`)}
    />
  );
};

export default SMJCmpSelectorHelperRender;
